/*
 * @Author: yeyimei
 * @Date: 2023-04-19 10:35:30
 * @LastEditTime: 2023-04-24 09:41:54
 * @LastEditors: yeyimei
 * @Description: 
 * @FilePath: \cardlan-h5-qrcode\src\router\invoice.routes.js
 */
export default [{
        path: '/invoice',
        name: 'invoice',
        component: () => import('@/views/invoice/index.vue'),
        meta: {
            title: '申请开票',
            showName: true
        },
    },
    {
        path: '/invoice-order-list',
        name: 'invoiceOrderList',
        component: () => import('@/views/invoice/orderList.vue'),
        meta: {
            title: '发票',
            showName: true
        },
    },
    {
        path: '/invoice-title',
        name: 'invoiceTitle',
        component: () => import('@/views/invoice/invoiceTitle.vue'),
        meta: {
            title: '添加发票抬头',
            showName: true
        },
    },
    {
        path: '/invoice-list',
        name: 'invoiceList',
        component: () => import('@/views/invoice/invoiceList.vue'),
        meta: {
            title: '发票中心',
            showName: true
        },
    },
    {
        path: '/invoice-detail',
        name: 'invoiceDetail',
        component: () => import('@/views/invoice/invoiceDetail.vue'),
        meta: {
            title: '发票详情',
            showName: true
        },
    },
    {
        path: '/invoice-order',
        name: 'invoiceOrder',
        component: () => import('@/views/invoice/invoiceOrder.vue'),
        meta: {
            title: '发票详情',
            showName: true
        },
    }

]